/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useAuthContext } from "../../hooks/useAuthContext";
import LinkComponent from "./components/Link/Link";
import Logo from "../Logo/Logo";

const SIDEBAR_WIDTH = 260;

function Sidebar({ PROTECTED_ROUTES }) {
  const { dispatch } = useAuthContext();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    Cookies.remove("user");
    dispatch({ type: "LOGOUT" });
    window.location.reload();
  };

  const navItems = PROTECTED_ROUTES.filter((route) => route.includedInSidebar);

  const sidebarContent = (
    <>
      <div className="flex h-16 shrink-0 items-center border-b border-slate-200/80 px-5">
        <Link to="/dashboard" className="group flex items-center no-underline text-xl">
          <Logo />
        </Link>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
        {navItems.map((route) => (
          <LinkComponent
            key={route.key}
            link={route.link}
            name={route.name}
            icon={route.icon}
            active={
              location.pathname === route.link ||
              (route.link !== "/dashboard" &&
                location.pathname.startsWith(route.link))
            }
          />
        ))}
      </nav>
      <div className="shrink-0 border-t border-slate-200/80 p-3">
        <button
          type="button"
          onClick={handleLogout}
          className="flex w-full items-center justify-center gap-2 rounded-lg border border-slate-200 bg-slate-50/80 px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100 hover:text-slate-900"
        >
          Log out
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Mobile: top bar with menu toggle */}
      <div className="fixed left-0 right-0 top-0 z-40 flex h-14 items-center justify-between border-b border-slate-200 bg-white px-4 lg:hidden">
        <button
          type="button"
          onClick={() => setMobileOpen((o) => !o)}
          className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
          aria-label="Toggle menu"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            {mobileOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
        <Link to="/dashboard" className="group flex items-center text-lg no-underline">
          <Logo />
        </Link>
        <div className="w-9" />
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-slate-900/30 backdrop-blur-sm lg:hidden"
          onClick={() => setMobileOpen(false)}
          aria-hidden
        />
      )}

      {/* Sidebar panel */}
      <aside
        className={`fixed left-0 top-0 z-40 flex h-full w-[var(--sidebar-width)] flex-col border-r border-slate-200/80 bg-white shadow-sm transition-transform duration-200 ease-out ${mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        style={{ "--sidebar-width": `${SIDEBAR_WIDTH}px` }}
      >
        <div className="flex h-full w-full flex-col pt-14 lg:pt-0">
          {sidebarContent}
        </div>
      </aside>

      {/* Desktop spacer */}
      <div className="hidden shrink-0 lg:block" style={{ width: `${SIDEBAR_WIDTH}px` }} />
    </>
  );
}

export default Sidebar;
